import React, { forwardRef, useEffect, useState } from 'react';
import IconWithButton from 'src/components/Common/IconWithButton';
import calenderIcon from 'src/assets/svgs/calenderIcon.svg';
import { breakPoints } from 'src/constants/general';
import { HiChevronDown } from 'react-icons/hi';

import DatePicker from 'react-datepicker';
import { useDeviceDetect } from 'src/hooks/useDeviceDetect';
import { dateTimeFormate, getSelectBoxOptions } from 'src/utils/function';
import { taskList } from 'src/services/Task';

const TaskProgressNoteSortFilter = ({ filterBy, setFilterBy, dateProps, setSelectedTaskId }: any) => {
    const { isMobile }: any = useDeviceDetect();
    const [calenderOpenDateTo, setCalenderOpenDateTo] = useState(false);
    const [calenderOpenDateFrom, setCalenderOpenDateFrom] = useState(false);
    const [taskListData, setTaskListData] = useState<any>([]);

    const { dateTo, setDateTo, formateDateTo, setFormateDateTo, dateFrom, setDateFrom, formateDateFrom, setFormateDateFrom } = dateProps;

    const getNewDate = (date: any) => {
        const newDate = new Date(date);
        return dateTimeFormate(newDate, 'DD MMM, YYYY');
    };

    useEffect(() => {
        const controller = new AbortController();
        getList(``, controller.signal);

        return () => controller.abort();
    }, []);

    const getList = async (url: string, signal?: any) => {
        try {
            const resData = await taskList(url, signal);
            const data = resData?.data?.data;
            const assignedToOptions = getSelectBoxOptions(data.tasks || [], 'id', 'title');
            setTaskListData(assignedToOptions);
        } catch (err) {}
    };

    const onChangeDateTo = (date: any) => {
        setDateTo(date);
        setCalenderOpenDateTo(false);
        if (date) {
            const formattedNewDateTo = getNewDate(date);
            setFormateDateTo(formattedNewDateTo);
            setFilterBy((prevData: any) => ({
                ...prevData,
                dateTo: dateTimeFormate(formattedNewDateTo, 'YYYY-MM-DD HH:mm:ss'),
            }));
        }
    };
    const onChangeDateFrom = (date: any) => {
        setDateFrom(date);
        setCalenderOpenDateFrom(false);
        if (date) {
            const formattedNewDateFrom = getNewDate(date);
            setFormateDateFrom(formattedNewDateFrom);
            setFilterBy((prevData: any) => ({
                ...prevData,
                dateFrom: dateTimeFormate(formattedNewDateFrom, 'YYYY-MM-DD HH:mm:ss'),
            }));
        }
    };

    const CustomDateToInput = forwardRef((props, ref: any) => (
        <div className="" ref={ref}>
            <IconWithButton title={formateDateTo} icon={calenderIcon} isMoreClass={'max-lg:py-3 max-lg:gap-2 max-lg:rounded-xl max-lg:w-full'} onclick={() => setCalenderOpenDateTo(true)} />
        </div>
    ));
    const CustomDateFromInput = forwardRef((props, ref: any) => (
        <div className="" ref={ref}>
            <IconWithButton title={formateDateFrom} icon={calenderIcon} isMoreClass={'max-lg:py-3 max-lg:gap-2 max-lg:rounded-xl max-lg:w-full'} onclick={() => setCalenderOpenDateFrom(true)} />
        </div>
    ));

    return (
        <div className="mt-4 px-5 md:px-5 h-[calc(100vh-270px)] overflow-y-auto scrollbar-hide">
            <h4 className="text-black text-base font-medium">Filter By</h4>

            <div
                className={`mt-6 mb-4 flex gap-2 max-lg:gap-0 max-lg:justify-between
                     ${isMobile < breakPoints.mobile ? 'mobile_datepicker_responsive' : isMobile < breakPoints.tablet ? 'tablet_datepicker_responsive' : ''}`}
            >
                <div className="flex flex-col">
                    <p className="text-xs mb-2">Date From</p>
                    <DatePicker
                        selected={dateFrom}
                        onChange={onChangeDateFrom}
                        open={calenderOpenDateFrom}
                        onClickOutside={() => setCalenderOpenDateFrom(false)}
                        customInput={<CustomDateFromInput />}
                        showPopperArrow={false}
                        calendarClassName="sort-custom-datepicker bg-black text-gray-100 w-[270px]"
                        // minDate={toDay.toDate()}
                    ></DatePicker>
                </div>
                <div className="flex flex-col">
                    <p className="text-xs mb-2">Date To</p>
                    <DatePicker
                        selected={dateTo}
                        onChange={onChangeDateTo}
                        open={calenderOpenDateTo}
                        onClickOutside={() => setCalenderOpenDateTo(false)}
                        customInput={<CustomDateToInput />}
                        showPopperArrow={false}
                        calendarClassName="sort-custom-datepicker bg-black text-gray-100 w-[270px]"
                        // minDate={toDay.toDate()}
                    ></DatePicker>
                </div>
            </div>
            <div className="mt-3">
                <div className="relative">
                    <select
                        id="selectBoxRequestor"
                        className="select_floating peer"
                        value={filterBy.title}
                        onChange={(e) => {
                            setFilterBy((prevData: any) => ({
                                ...prevData,
                                title: e.target.value,
                            }));
                            setSelectedTaskId((prevData: any) => ({
                                ...prevData,
                                id: e.target.value,
                            }));
                        }}
                    >
                        <option value={''}>All</option>
                        {taskListData?.map((data: any, index: number) => (
                            <option key={index} value={data.value}>
                                {data.name}
                            </option>
                        ))}
                    </select>

                    <label htmlFor="selectBoxRequestor" className="floating_label">
                        Task Title
                    </label>
                    <span className="absolute top-1/2 -translate-y-1/2 right-3 text-gray80">
                        <HiChevronDown size={20} />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default TaskProgressNoteSortFilter;
